import { Helmet } from "react-helmet-async";
import { Navigate, useLocation } from "react-router-dom";
import { canonicalUrl } from "@/lib/app-config";

/**
 * Redirect for pages that moved.
 *
 * This app is a static SPA, so a true server-side 301 isn't available. This
 * component gives crawlers the two signals that consolidate ranking anyway:
 *   1. `<link rel="canonical">` pointing at the new URL
 *   2. an immediate client-side navigation (history replace, so the old URL
 *      leaves no back-button entry)
 * plus `noindex` so the legacy path drops out of the index once the new URL
 * is picked up.
 */
export function MovedPermanently({ to }: { to: string }) {
  const location = useLocation();
  const target = `${to}${location.search}${location.hash}`;

  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl(to)} />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Navigate to={target} replace />
    </>
  );
}

export default MovedPermanently;
